import z from "zod";

export const clientRouterDataSchema = z.object({
  /** The path the page is served under, which the router hangs its own from. */
  basepath: z
    .string()
    .optional()
    // Trailing slash trimmed: the route generates the path with an optional
    // last segment, and the router matches its own base without one.
    .transform((value) => (value ?? "/client").replace(/\/+$/u, "") || "/"),

  /** Which clients the list opens on, as the two menu entries do. */
  filter: z
    .enum(["active", "archived", "all"])
    .optional()
    .transform((value) => value ?? "active"),
});

export type ClientRouterDataProps = z.infer<typeof clientRouterDataSchema>;
